import { loadGoogleMaps } from './loadGoogleMaps';

// Pricing config (CHF). distancePrice = max(MIN, BASE + PER_KM * km)
export const PRICING = { BASE: 30, PER_KM: 3.5, MIN: 60 };

// Compute driving distance (km) & duration (min) between two address strings.
// Returns { km, min } or null if it cannot be computed.
export async function getDistance(origin, destination) {
  if (!origin || !destination) return null;
  try {
    const google = await loadGoogleMaps();
    if (!google?.maps) return null;
    const service = new google.maps.DistanceMatrixService();
    const res = await service.getDistanceMatrix({
      origins: [origin],
      destinations: [destination],
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.METRIC,
    });
    const el = res?.rows?.[0]?.elements?.[0];
    if (!el || el.status !== 'OK') return null;
    return {
      km: Math.round((el.distance.value / 1000) * 10) / 10,
      min: Math.round(el.duration.value / 60),
    };
  } catch (e) {
    return null;
  }
}

export function priceForKm(km, v = 1) {
  if (!km || km <= 0) return null;
  if (typeof v !== 'object') v = { priceFactor: v };
  const f = Number(v.priceFactor) || 1;
  const rate = Number(v.perKm) || PRICING.PER_KM * f;
  return Math.round(Math.max(Number(v.minFare) || PRICING.MIN * f, (Number(v.baseFare) || PRICING.BASE * f) + rate * km));
}
